import { createApp } from 'vue'
import App from './App.vue'
import PrimeVue from 'primevue/config'
import Aura from '@primeuix/themes/aura';
import ToastService from 'primevue/toastservice';
import 'primeicons/primeicons.css'
import ConfirmationService from 'primevue/confirmationservice';
import router from './router'


const app = createApp(App)

app.use(ToastService)
app.use(ConfirmationService)
app.use(PrimeVue, { theme: { preset: Aura,
                             options: {
                               prefix: 'p',
                               darkModeSelector: 'light',
                               cssLayer: false
                             }} })
app.use(router)
app.mount('#app')
